<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Planes</span>
  
  </mat-toolbar>
  
  <div class="margin-container apearAnimation">

    
    <div class="mat-elevation-z0 contenedorTabla">
      <table mat-table [dataSource]="dataSource">
  
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
        </ng-container>

          <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef>descripción</th>
            <td mat-cell *matCellDef="let element">{{ element.descripcion }}</td>
          </ng-container>

          <ng-container matColumnDef="mesesDeVigencia">
            <th mat-header-cell *matHeaderCellDef>Vigencia (meses)</th>
            <td mat-cell *matCellDef="let element">{{ element.mesesDeVigencia }}</td>
          </ng-container>

          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef>Valor</th>
            <td mat-cell *matCellDef="let element">${{ element.valor }}</td>
          </ng-container>

  
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
  
    </div>
  </div>
  